// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PBackwardOutlinedSvg from "@fishx/icons-svg/es/asn/PBackwardOutlined";
import FishxIcon from '../components/FishxIcon';

var PBackwardOutlined = function PBackwardOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PBackwardOutlinedSvg
  }));
};

PBackwardOutlined.displayName = 'PBackwardOutlined';
export default React.forwardRef(PBackwardOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PBackwardOutlined.js
// module id = 3225
// module chunks = 0